export default {"src":"/_next/static/media/whatsApp.4e5770d7.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};